module.exports = __webpack_public_path__ + "img/per@2x.6df87ae2.png";